import Component from './Component';
import { onScroll, onResizeDebounced } from '../services/ScrollResizeHandler';
import { isInViewport } from '../utilities/is_in_viewport';
import CountUp from 'countup.js';

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */

let counters = [];
let newCounter;
let counterElm;
let rafTimer;

const easingFn = function (t, b, c, d) {
  var ts = (t /= d) * t;
  var tc = ts * t;
  return b + c * (tc * ts + -5 * ts * ts + 10 * tc + -10 * ts + 5 * t);
}

const _defaultOptions = {
    useEasing: true,
    easingFn: easingFn,
    useGrouping: true,
    separator: ',',
    decimal: '.'
}


const countDecimal = function (value) {
    if ((value % 1) != 0) {
        return value.toString().split('.')[1].length;
    }

    return 0;
}



/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */







/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class Counter extends Component {

    decorator () {
        return {
            selector : '.js-counter',
            name : 'Counter',
        }
    }


    constructor(element) {
        super(element);

        // INITIAL CALLS
        this.cacheElements();

        this.startCounter.bind(window);

        onScroll(this.startCounter.bind(this));

        onResizeDebounced(this.startCounter.bind(this));
    }


    cacheElements () {
        const _obj = {
            selector: this.element,
            digit: this.element.getAttribute('data-counter-digit'),
            digitSelector: this.element.querySelector('.js-counter-digit'),
        }

        const decimal = countDecimal(_obj.digit);

        newCounter = new CountUp(_obj.digitSelector, 0, _obj.digit, decimal, 2.5, _defaultOptions);

        counters.push(newCounter);
    }


    startCounter () {
        const checkIfElementIsInViewport = () => {

            for (let i=0; i < counters.length; i++) {

                let isActivated = false;
                counterElm = isInViewport(counters[i].d);

                if (counterElm && !isActivated) {
                    setTimeout(()=> {
                        counters[i].start();
                    }, 500);

                    isActivated = true;
                }
            }
        }

        cancelAnimationFrame(rafTimer);

        rafTimer = window.requestAnimationFrame(checkIfElementIsInViewport);
    }


}
